import Beacons from 'modules/beacons/utils';
import { QuartileKey } from 'tag/models/common/common';

export const thirdQuartileListener = (adserverRequestId: string) => {
  Beacons.fire.videoQuartile(QuartileKey.Q75, adserverRequestId, true);
};
